import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../hooks/useMainContext';
import LoadingScreen from '../Globle/LoadingScreen';
import { message } from 'antd';
import { SERVER_BASE_URL } from '../../__common/env';

const OidcCallback = observer(() => {
    const auth = useAuth();
    const navigate = useNavigate();
    const { viewManager } = useMainContext();
    const getUser = async () => {
        // const token = await getIdToken();
        const token = auth.user?.id_token;
        const response = await fetch(`${SERVER_BASE_URL}/user/profile`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
    };
    useEffect(() => {
        const handleCallback = async () => {
            try {
                if (auth.isLoading) return;

                if (auth.error) {
                    console.error('OIDC Authentication error:', auth.error);
                    message.error('Authentication failed. Please try again.');
                    navigate('/auth/login');
                    return;
                }

                if (auth.isAuthenticated && auth.user) {
                    // Set user data from Google OAuth
                    const user = auth.user?.profile;
                    const userData = {
                        name:
                            user.name ||
                            `${user.given_name || ''} ${user.family_name || ''}`.trim(),
                        firstName:
                            user.given_name || user.name?.split(' ')[0] || '',
                        lastName:
                            user.family_name || user.name?.split(' ')[1] || '',
                        email: user.email,
                        sub: user.sub,
                        authProvider: 'google',
                    };

                    viewManager.setUserData(userData);
                    viewManager.setIsLoggedIn(true);
                    getUser();

                    message.success('Logged in successfully ');
                    navigate('/');
                } else {
                    // Still processing or no user data yet
                    console.warn('Waiting for authentication to complete...');
                }
            } catch (error) {
                console.error('Error handling OIDC callback:', error);
                message.error('Authentication failed. Please try again.');
                navigate('/auth/login');
            }
        };

        handleCallback();
    }, [
        auth.isLoading,
        auth.error,
        auth.isAuthenticated,
        auth.user,
        navigate,
        viewManager,
    ]);

    if (auth.isLoading) {
        return <LoadingScreen />;
    }

    return <LoadingScreen />;
});

export default OidcCallback;
